import { formatNumber } from './currency';

export function formatWeight(value: number, unit: string, locale: string): string {
  return `${formatNumber(value, locale, 2)} ${unit.toLowerCase()}`;
}

export function formatDimensions(
  length: number,
  width: number,
  height: number,
  unit: string,
  locale: string,
): string {
  const fmt = (n: number) => formatNumber(n, locale, 1);
  // Displayed as height × width × length - InPost's own order for its locker sizes (A = 8 × 38 × 64).
  return `${fmt(height)} × ${fmt(width)} × ${fmt(length)} ${unit.toLowerCase()}`;
}
